export default "__VITE_ASSET__BhoXiEMw__ 600w";